const ZENDESK_EDITOR_BASE_URL = 'https://clinchflightcontrol.zendesk.com/knowledge/articles/';
const ZENDESK_EDITOR_PARAMS = '/en-us';
const CLONED_DRAFT_PREFIX = 'DRAFTOF:';

export {ZENDESK_EDITOR_BASE_URL, ZENDESK_EDITOR_PARAMS, CLONED_DRAFT_PREFIX};
